// TEMP dev-only preview: shell + topbar account + real dashboard. Delete after review.
import { SuiAppShell, type SuiAgentRef } from "@/components/SuiAppShell";
import { SuiDashboardPage } from "@/pages/SuiDashboard";
import type { AgentObject } from "@/lib/api";

const navAgents: SuiAgentRef[] = [
  { id: "0xa1b2", name: "orca-trader-2", status: "active" },
  { id: "0xc3d4", name: "deepbook-mm", status: "active" },
  { id: "0xe5f6", name: "yield-router", status: "paused" },
  { id: "0x7890", name: "arb-sweeper-1", status: "revoked" },
];

const now = Date.now();
const mockAgents = [
  { id: "0xa1b2", name: "orca-trader-2", status: "active", chain: "sui", framework: "sak", created_at: new Date(now - 9_000_000).toISOString(),
    policy: { per_asset_caps: [{ asset: "USDC", per_day: 5000, per_tx: 1000, spent_today: 3120 }], allowed_actions: ["deepbook_swap", "deepbook_limit"], expires_at: new Date(now + 18 * 3600_000).toISOString() } },
  { id: "0xc3d4", name: "deepbook-mm", status: "active", chain: "sui", framework: "custom", created_at: new Date(now - 400_000).toISOString(),
    policy: { per_asset_caps: [{ asset: "SUI", per_day: 40, per_tx: 5, spent_today: 38.2 }], allowed_actions: ["deepbook_swap", "deepbook_limit", "deepbook_cancel"], expires_at: new Date(now + 6 * 3600_000).toISOString() } },
  { id: "0x7890", name: "arb-sweeper-1", status: "revoked", chain: "sui", framework: "sak", created_at: new Date(now - 90_000_000).toISOString(), revoked_at: new Date(now - 80_000_000).toISOString(),
    policy: { per_asset_caps: [{ asset: "USDC", per_day: 2000 }], allowed_actions: ["deepbook_swap"], expires_at: "" } },
] as unknown as AgentObject[];

function MockAccount() {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 8, height: 34, padding: "0 12px", border: "1px solid var(--line)", borderRadius: "var(--radius-pill)", background: "var(--bg-elev)", font: "var(--type-mono-address)", color: "var(--bone)" }}>
      <span style={{ width: 7, height: 7, borderRadius: "50%", background: "var(--accent)", boxShadow: "0 0 0 3px var(--accent-glow)" }} />
      0x9a7c…9b8a
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--slate-2)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
    </span>
  );
}

export function PreviewShellPage() {
  return (
    <SuiAppShell agents={navAgents} account={<MockAccount />}>
      <SuiDashboardPage agents={mockAgents} />
    </SuiAppShell>
  );
}
